import * as actionTypes from '../../actionTypes';
import axios from '../../../../_services/api/axios';

/* ------------------ Job Create ------------------- */
export const calculatorJobCreateStart = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_CREATE_START
    };
};

export const calculatorJobCreateSuccess = (details) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CREATE_SUCCESS,
        details: details
    };
};

export const calculatorJobCreateFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CREATE_FAIL,
        error: error
    };
};

export const calculatorJobCreateReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CREATE_RESET
    };
};

export const calculatorJobCreate = (formData) => {
    return dispatch => {
        dispatch(calculatorJobCreateStart());
        axios.post( '/production/calculator/jobs', formData)
            .then( response => {
                dispatch( calculatorJobMessageSet({
                    key: 'created',
                    type: 'success'
                }) );
                dispatch( calculatorJobCreateSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( calculatorJobCreateFail( error ) );               
            } );
    };
};

/* ----------------- Job Duplicate ------------------ */
export const calculatorJobDuplicateCheckSuccess = ( name_duplicate ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DUPLICATECHECK_SUCCESS,
        name_duplicate: name_duplicate
    };
};

export const calculatorJobDuplicateCheckFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DUPLICATECHECK_FAIL,
        error: error
    };
};

export const calculatorJobDuplicateCheckStart = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_DUPLICATECHECK_START
    };
};

export const calculatorJobDuplicateCheckReset = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_DUPLICATECHECK_RESET
    };
};

export const calculatorJobDuplicateCheck = (formData) => {
    return dispatch => {
        dispatch(calculatorJobDuplicateCheckStart());
        let urlString =  '/production/calculator/jobs/duplicate?name='+formData.name;
        if(formData.id) {
            urlString = urlString + "&jobId=" + formData.id;
        }
        axios.get( urlString , { hideGlobalSpinner : true })
            .then( response => {
                dispatch( calculatorJobDuplicateCheckSuccess( response.data.result ) );
            } )
            .catch( error => {
                dispatch( calculatorJobDuplicateCheckFail( error ) );              
            } );
    };
};

/* ------------------ Job Fetch ------------------- */
export const calculatorJobFetchStart = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_FETCH_START
    };
};

export const calculatorJobFetchSuccess = (details) => {
    return {
        type: actionTypes.CALCULATOR_JOB_FETCH_SUCCESS,
        details: details
    };
};

export const calculatorJobFetchFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_FETCH_FAIL,
        error: error
    };
};

export const calculatorJobFetchReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_FETCH_RESET
    };
};

export const calculatorJobFetch = (id) => {
    return dispatch => {
        dispatch(calculatorJobFetchStart());
        axios.get( '/production/calculator/jobs/'+id)
            .then( response => {
                dispatch( calculatorJobFetchSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( calculatorJobFetchFail( error ) );              
            } );
    };
};
/* ------------------ Job Message ------------------- */
export const calculatorJobMessageSet = ( message ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_MESSAGE_SET,
        message: message
    };
};
export const calculatorJobMessageReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_MESSAGE_RESET
    };
};

/* ------------------ Job Machine Fetch ------------------- */
export const calculatorJobMachineFetchStart = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_MACHINE_FETCH_START
    };
};

export const calculatorJobMachineFetchSuccess = (details) => {
    return {
        type: actionTypes.CALCULATOR_JOB_MACHINE_FETCH_SUCCESS,
        details: details
    };
};

export const calculatorJobMachineFetchFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_MACHINE_FETCH_FAIL,
        error: error
    };
};

export const calculatorJobMachineFetchReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_MACHINE_FETCH_RESET
    };
};

export const calculatorJobMachineFetch = (id) => {
    return dispatch => {
        dispatch(calculatorJobMachineFetchStart());
        axios.get( '/production/calculator/jobs/'+id+'/machine')
            .then( response => {
                dispatch( calculatorJobMachineFetchSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( calculatorJobMachineFetchFail( error ) );              
            } );
    };
};

/* ------------------ Job Calculations Fetch ------------------- */
export const calculatorJobCalculationsFetchStart = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_CALCULATIONS_FETCH_START
    };
};

export const calculatorJobCalculationsFetchSuccess = (details) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS,
        details: details
    };
};

export const calculatorJobCalculationsFetchFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL,
        error: error
    };
};

export const calculatorJobCalculationsFetchReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CALCULATIONS_FETCH_RESET
    };
};

export const calculatorJobCalculationsFetch = (id) => {
    return dispatch => {
        dispatch(calculatorJobCalculationsFetchStart());
        axios.get( '/production/calculator/jobs/'+id+'/calculations')
            .then( response => {
                dispatch( calculatorJobCalculationsFetchSuccess( response.data.list ) );
            } )
            .catch( error => {
                dispatch( calculatorJobCalculationsFetchFail( error ) );              
            } );
    };
};

/* ------------------ Job Export Fetch ------------------- */
export const calculatorJobExportFetchStart = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_EXPORT_FETCH_START
    };
};

export const calculatorJobExportFetchSuccess = (filebody,filename) => {
    return {
        type: actionTypes.CALCULATOR_JOB_EXPORT_FETCH_SUCCESS,
        filebody: filebody,
        filename: filename
    };
};

export const calculatorJobExportFetchFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_EXPORT_FETCH_FAIL,
        error: error
    };
};

export const calculatorJobExportFetchReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_EXPORT_FETCH_RESET
    };
};

export const calculatorJobExportFetch = (id, type, language = 'en') => {
    return dispatch => {
        dispatch(calculatorJobExportFetchStart());
        axios.get( '/production/calculator/jobs/'+id+'/export?culture='+language, {
                data: {},
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/'+type
                }
            })
            .then( response => {
                dispatch( calculatorJobExportFetchSuccess( response.data, response.headers["x-filename"] ) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: "default", message: "There was an error, please try it again later.", type: 'error', obj: error} } ); 
                } 
                dispatch( calculatorJobExportFetchFail( error ) );              
            } );
    };
};

/* ------------------ Job Update ------------------- */
export const calculatorJobUpdateStart = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_UPDATE_START
    };
};

export const calculatorJobUpdateSuccess = (details) => {
    return {
        type: actionTypes.CALCULATOR_JOB_UPDATE_SUCCESS,
        details: details
    };
};

export const calculatorJobUpdateFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_UPDATE_FAIL,
        error: error
    };
};

export const calculatorJobUpdateReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_UPDATE_RESET
    };
};

export const calculatorJobUpdate = (id, formData) => {
    return dispatch => {
        dispatch(calculatorJobUpdateStart());
        axios.put( '/production/calculator/jobs/'+id, formData)
            .then( response => {
                dispatch( calculatorJobUpdateSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( calculatorJobUpdateFail( error ) );             
            } );
    };
};

/* ------------------ Job Machine Update ------------------- */
export const calculatorJobMachineUpdateStart = () => {
    return {
        type: actionTypes.CALCULATOR_JOB_MACHINE_UPDATE_START
    };
};

export const calculatorJobMachineUpdateSuccess = (settings) => {
    return {
        type: actionTypes.CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS,
        settings: settings
    };
};

export const calculatorJobMachineUpdateFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_MACHINE_UPDATE_FAIL,
        error: error
    };
};

export const calculatorJobMachineUpdateReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_MACHINE_UPDATE_RESET
    };
};

export const calculatorJobMachineUpdate = (id, formData) => {
    return dispatch => {
        dispatch(calculatorJobMachineUpdateStart());
        axios.put( '/production/calculator/jobs/'+id+'/machine/settings', formData)
            .then( response => {
                dispatch( calculatorJobMachineUpdateSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( calculatorJobMachineUpdateFail( error ) );             
            } );
    };
};

/* ------------------ Job Delete ------------------- */
export const calculatorJobDeleteStart = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DELETE_START
    };
};

export const calculatorJobDeleteSuccess = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DELETE_SUCCESS
    };
};

export const calculatorJobDeleteFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DELETE_FAIL,
        error: error
    };
};

export const calculatorJobDeleteReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DELETE_RESET
    };
};

export const calculatorJobDelete = (id, formData) => {
    return dispatch => {
        dispatch(calculatorJobDeleteStart());
        axios.delete( '/production/calculator/jobs/'+id, formData)
            .then( response => {
                dispatch( calculatorJobMessageSet({
                    key: 'deleted',
                    type: 'success'
                }) );
                dispatch( calculatorJobDeleteSuccess( ) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: "default", message: "There was an error, please try it again later.", type: 'error', obj: error} } ); 
                }
                dispatch( calculatorJobDeleteFail( error ) );             
            } );
    };
};

/* ------------------ Job Change Active ------------------- */
export const calculatorJobChangeActiveStart = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CHANGEACTIVE_START
    };
};

export const calculatorJobChangeActiveSuccess = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CHANGEACTIVE_SUCCESS
    };
};

export const calculatorJobChangeActiveFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CHANGEACTIVE_FAIL,
        error: error
    };
};

export const calculatorJobChangeActiveReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_CHANGEACTIVE_RESET
    };
};

export const calculatorJobChangeActive = (id, formData) => {
    return dispatch => {
        dispatch(calculatorJobChangeActiveStart());
        axios.put( '/production/calculator/jobs/'+id+'/machine/changeactive', formData)
            .then( response => {
                dispatch( calculatorJobMessageSet({
                    key: 'used_machine',
                    type: 'success'
                }) );
                dispatch( calculatorJobChangeActiveSuccess( ) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: "default", message: "There was an error, please try it again later.", type: 'error', obj: error} } ); 
                }
                dispatch( calculatorJobChangeActiveFail( error ) );             
            } );
    };
};

/* ------------------ Recalculate Active ------------------- */
export const calculatorJobRecalculateStart = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_RECALCULATE_START
    };
};

export const calculatorJobRecalculateSuccess = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_RECALCULATE_SUCCESS
    };
};

export const calculatorJobRecalculateFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_RECALCULATE_FAIL,
        error: error
    };
};

export const calculatorJobRecalculateReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_RECALCULATE_RESET
    };
};

export const calculatorJobRecalculate = (id) => {
    return dispatch => {
        dispatch(calculatorJobRecalculateStart());
        axios.get( '/production/calculator/jobs/'+id+'/applyglobalsettings')
            .then( response => {
                dispatch( calculatorJobMessageSet({
                    key: 'recalculated',
                    type: 'success'
                }) );
                dispatch( calculatorJobRecalculateSuccess( ) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: "default", message: "There was an error, please try it again later.", type: 'error', obj: error} } ); 
                } 
                dispatch( calculatorJobRecalculateFail( error ) );             
            } );
    };
};

/* ------------------ Detailed Calculation ------------------- */
export const calculatorJobDetailedCalculationStart = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DETAILED_CALCULATION_START
    };
};

export const calculatorJobDetailedCalculationSuccess = ( details ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS,
        details: details
    };
};

export const calculatorJobDetailedCalculationFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DETAILED_CALCULATION_FAIL,
        error: error
    };
};

export const calculatorJobDetailedCalculationReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_JOB_DETAILED_CALCULATION_RESET
    };
};

export const calculatorJobDetailedCalculation = (jobId, calculationId) => {
    return dispatch => {
        dispatch(calculatorJobDetailedCalculationStart());
        axios.get( '/production/calculator/jobs/'+jobId+'/calculations/'+calculationId+'/details')
            .then( response => {
                dispatch( calculatorJobDetailedCalculationSuccess( response.data ) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "job", key: "default", message: "There was an error, please try it again later.", type: 'error', obj: error} } ); 
                } 
                dispatch( calculatorJobDetailedCalculationFail( error ) );             
            } );
    };
};



// WEBPACK FOOTER //
// ./src/_store/actions/calculator/jobs/job.js